import React from 'react';
import { Modal } from '@mantine/core';

import { useObjectStore } from "../zustand/objects";

import ImagesAPIMapped from "./ImagesAPIMapped";
import FigmaModalContents from "./FigmaModalContents";
import { editorModalShell, editorModalStrongTitleStyles } from "../styleFile";


export default function ImageModal({ id }) {


  const {
    imageModalOpen,
    switchImageModalOpen,
    imagePurpose,
    setImagePurpose
  } = useObjectStore();

  const onImageCancel = () => {
    switchImageModalOpen(null)
    setImagePurpose(null)

  }

  const modalBase = {
    opened: imageModalOpen,
    onClose: onImageCancel,
    withCloseButton: true,
    size: 560,
    radius: editorModalShell.radius,
    centered: editorModalShell.centered,
    overlayProps: editorModalShell.overlayProps,
    styles: editorModalStrongTitleStyles,
  };

  if (imagePurpose === "objectEdit") {
    return (
      <Modal
        {...modalBase}
        title="Image library"
      >
        {imageModalOpen && <ImagesAPIMapped id={id} />}
      </Modal>
    )
  }

  else if (imagePurpose === "object") {
    return (
      <Modal {...modalBase} title="Image library">
        {imageModalOpen && <ImagesAPIMapped id={id} />}
      </Modal>
    )
  }

  else if (imagePurpose === "texture") {
    return (
      <Modal
        {...modalBase}
        title="Image texture"
      >
        {imageModalOpen && <ImagesAPIMapped id={id} />}
      </Modal>
    )
  }

  else if (imagePurpose === "figma") {
    return (
      <Modal
        {...modalBase}
        title="Figma frames"
      >
        <FigmaModalContents />
      </Modal>
    )
  }

  return null;
}
